import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';

export class Transaction {
  user!: User;
  currency!: Currency;
  description!: string;
  amount!: number;
  constructor(input: any = {}) {
    this.user = new User(input.user);
    this.currency = new Currency(input.currency);
    this.description = input.description;
    this.amount = +input.amount;
    if (this.currency.id === 'IRR') {
      this.amount = Math.floor(this.amount / 10);
    }
  }
}
